import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AddAllStock } from '../add-all-stock/add-all-stock';
import { AddAllStockForm } from '../../../../components/admin-dashboard-component/add-all-stock-form/add-all-stock-form';

@Component({
  selector: 'app-edit-stock',
  imports: [AddAllStockForm],
  templateUrl: './edit-stock.html',
  styleUrl: './edit-stock.scss',
})
export class EditStock implements OnInit {
  private route = inject(ActivatedRoute);
  stockId = signal('');
  ngOnInit(): void {
    const stockId = this.route.snapshot.params['id'];
    this.stockId.set(stockId);
  }
}
